export const LOBBY_PRIMARY_ACTION_TYPES = {
  ACTIVE_GAME: 'ACTIVE_GAME',
  CUSTOM_URL: 'CUSTOM_URL',
  PROMOTION: 'PROMOTION',
  REFER_A_FRIEND: 'REFER_A_FRIEND',
  SMARTICO_MINI_GAMES: 'SMARTICO_MINI_GAMES',
  SMARTICO_MISSIONS: 'SMARTICO_MISSIONS',
  SMARTICO_STORE: 'SMARTICO_STORE',
  TOURNAMENT: 'TOURNAMENT',
  URL: 'URL',
};

export const LOBBY_PRIMARY_BREAKPOINTS = {
  1: {
    slidesPerView: 6,
  },
  1000: {
    slidesPerView: 8,
  },
  1250: {
    slidesPerView: 10,
  },
  1550: {
    slidesPerView: 11,
  },
  850: {
    slidesPerView: 7,
  },
};
